import { PublicClientApplication } from "@azure/msal-browser";
// export const BASE_URL = "https://localhost:7176";

export const BASE_URL = "https://gd-surveillance-api.azurewebsites.net";

export const Client_id =
  "875838615965-k4ui5vc23fdtgjaa5nvg4er82h2a3pe1.apps.googleusercontent.com";

export const Role = [
  { value: 100, label: "Super Admin" },
  { value: 200, label: "Admin" },
  { value: 300, label: "User" },
];

const msalConfig = {
  auth: {
    clientId: "10608ece-ac47-4208-b5ba-383d88675041",
    authority:
      "https://login.microsoftonline.com/bef898b5-25e5-4796-93ab-11f861b61208",
    // redirectUri: "http://localhost:3000",
    redirectUri: "https://gd-surveillance.azurewebsites.net",
  },
  // Additional configuration as needed
};

const msalInstance = new PublicClientApplication(msalConfig);
export default msalInstance;
